import React, { useState, useEffect, useContext } from "react";
import { NotificationBadge } from "../components/common/NotificationBadge";
import { DashboardContext } from "../contexts/dashboardContext";
import { getDueResponseCount } from "../services/dashApiService";

export const NavBarRegReports = ({ onSelectActions, showNurseToDo, tab }) => {
	const { dueReportsCount, setDueReportsCount } = useContext(DashboardContext);
	const [activeButton, setActiveButton] = useState();

	const keyToActionsMap = {
		completed: ["Missed", "Complete"],
		due: ["Due by"],
		upcoming: ["Upcoming"],
		nurseToDo: ["Nurse Only"],
	};

	const handleClick = (id) => {
		setActiveButton(id);
		onSelectActions(keyToActionsMap[id]);
		getDueResponseCount()
			.then((data) => {
				setDueReportsCount(data.data);
			})
			.catch(() => {});
	};

	useEffect(() => {
		handleClick(tab || "due");
	}, [tab]);

	return (
		<ul className={`flex flex-row mx-auto btnSlider`}>
			<li className={"flex-1 relative mr-1.5"}>
				<button
					onClick={() => handleClick("completed")}
					className={
						activeButton === "completed"
							? "active-button"
							: "w-full text-sm py-2.5 rounded-full bg-gray-100 text-black"
					}
				>
					Completed
				</button>
			</li>

			<li className={"flex-1 relative mr-1.5"}>
				<NotificationBadge
					count={dueReportsCount.todo}
					classes={"absolute z-10 -top-2 right-2"}
				/>
				<button
					onClick={() => handleClick("due")}
					className={
						activeButton === "due"
							? "active-button"
							: "w-full text-sm py-2.5 rounded-full bg-gray-100 text-black"
					}
				>
					Due
				</button>
			</li>

			<li className={"flex-1 relative"}>
				<button
					onClick={() => handleClick("upcoming")}
					className={
						activeButton === "upcoming"
							? "active-button"
							: "w-full text-sm py-2.5 rounded-full bg-gray-100 text-black"
					}
				>
					Upcoming
				</button>
			</li>

			{showNurseToDo && (
				<li className={"flex-1 relative ml-1.5"}>
					<NotificationBadge
						count={dueReportsCount.nursetodo}
						classes={"absolute z-10 -top-2 right-2"}
					/>
					<button
						onClick={() => handleClick("nurseToDo")}
						className={
							activeButton === "nurseToDo"
								? "active-button"
								: "w-full text-sm py-2.5 rounded-full bg-gray-100 text-black"
						}
					>
						Nurses
					</button>
				</li>
			)}
		</ul>
	);
};
